export const BACKDROP_Z_INDEX = 100;
export const BACKDROP_TRANSITION_DURATION_MILLIS = 300;
export const BACKDROP_COLOR = 'rgba(0, 0, 0, 0.75)';
